import httpClient from '../httpClient';

const getAll = async () => {
  return await httpClient.get(`/jobs/`);
};

export { getAll };
